



































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbSelect } from '@folky-tools/mdbvue';
import { Category } from '@/models/references-classification/category';
import { referencesClassificationService } from '@/services';

@Component({
    components: {
        mdbRow,
        mdbCol,
        mdbSelect,
        ReferenceCategories: () => import('@/components/references/ReferenceCategories.vue')
    }
})
export default class ReferenceCategories extends Vue {
    @Prop() private readOnly!: boolean;
    @Prop() private businessId!: number;
    @Prop() private initialSelectedCategories!: Category[];
    @Prop() private categories!: Category[];
    @Prop() private isTopLevelCategory!: boolean;
    private subcategories: Category[] = [];

    private beforeMount(): void {
        this.$parent.$on('clearAnteriorCategorySelection', this.clearAnteriorCategorySelection);
    }

    private async mounted(): Promise<void> {
        if (this.categories.some(c => c.selected === true)) {
            const selectedCategory = this.categories.find(c => c.selected === true)!;
            await this.onChangeCategory(selectedCategory.id!, selectedCategory.text, true);
        }
    }

    private async onChangeCategory(value: number, text?: string, loadingData: boolean = false): Promise<void> {
        if (value > 0) {
            this.raiseOnChangeCategoryEvent(this.categories.find(c => c.id === value)!, loadingData);
            const subcategories = await referencesClassificationService.getCategoriesByParentId(this.businessId, value);

            if (subcategories && subcategories.length > 0) {
                subcategories.forEach(c => {
                    c.level = this.categories.find(c => c.id === value)!.level! + 1;
                    if (this.initialSelectedCategories.some(sc => sc.id === c.id)) {
                        c.selected = true;
                    }
                });

                this.subcategories = [
                    new Category({
                        id: -1,
                        businessId: this.businessId,
                        parentCategoryId: subcategories[0].parentCategoryId,
                        name: this.$t('common.ellipsis').toString(),
                        level: subcategories[0].level,
                        selected: !subcategories.some(c => c.selected === true)
                    }),
                    new Category({
                        id: 0,
                        businessId: this.businessId,
                        parentCategoryId: subcategories[0].parentCategoryId,
                        level: subcategories[0].level,
                        disabled: true,
                        optgroup: true
                    })
                ].concat(
                    subcategories.sort((left: Category, right: Category) => {
                        return left.text!.localeCompare(right.text!, this.$i18n.locale, { sensitivity: 'base' });
                    })
                );
            } else {
                this.subcategories = [];
            }
        } else {
            this.subcategories = [];
            const selectedCategory = this.categories.find(c => c.id === value);
            if (selectedCategory && selectedCategory.parentCategoryId) {
                this.raiseOnChangeCategoryEvent(await referencesClassificationService.getCategoryById(this.businessId, selectedCategory.parentCategoryId), loadingData);
            } else {
                this.raiseOnChangeCategoryEvent(new Category(), loadingData);
            }
        }
        this.categories
            .filter(c => c.id !== value)
            .forEach(c => {
                c.selected = false;
                this.$emit('clearAnteriorCategorySelection', c.id);
            });
    }

    private raiseOnChangeCategoryEvent(selectedCategory: Category, loadingData: boolean = false) {
        this.$emit('onChangeCategory', selectedCategory, loadingData);
    }

    private clearAnteriorCategorySelection(categoryId: number) {
        if (this.categories.some(c => c.parentCategoryId === categoryId)) {
            this.categories.forEach(c => (c.selected = false));
            this.categories.forEach(c => this.$emit('clearAnteriorCategorySelection', c.id));
            this.subcategories = [];
        }
    }
}
